import React, { useCallback } from 'react';
import { EDDialog } from '../../BaseComponents/Dialog/EDDialog';
import { useCommit } from '../../Hooks/useCommit';
import { CookieSettings } from './CookieSettings';
import { CONSENT_ALL, IConsent } from './CookieSettingsUtils';

interface IProps {
  consent: IConsent;
  setConsent: (consent: IConsent) => void;
  open: boolean;
  onClose?: () => void;
}
export const CookieSettingsDialog: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { onClose } = props;
  const {
    localState: selectedConsent,
    localSetter: setSelectedConsent,
    commit,
    cancel,
  } = useCommit(props.consent, props.setConsent);

  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  /** Återställ värdet om man stänger med krysset */
  const onCancelClose = useCallback(() => {
    cancel(), onClose?.();
  }, [cancel, onClose]);

  return (
    <EDDialog
      open={props.open}
      onClose={onCancelClose}
      title="Inställningar för datainsamling"
      footerActions={[
        {
          onClick: () => {
            commit(CONSENT_ALL);
            handleClose();
          },
          label: 'Tillåt alla',
        },
        {
          onClick: () => {
            commit(value => ({ ...value, necessary: true })); //lägg alltid till necessary som användaren inte kryssar själv
            handleClose();
          },
          label: 'Spara valda alternativ',
        },
      ]}
    >
      <CookieSettings
        consent={selectedConsent}
        setConsent={setSelectedConsent}
      />
    </EDDialog>
  );
};
